<template>
  <div class="infinity_scroll_table">
    <div class="infinity_scroll_table_wrap" :style="{'height': infinityScroll ? '100%' : 'calc(100% - 34px)'}">
      <table>
        <thead>
        <tr v-for="(headerList, idx) in depthHeaders" :key="`head-tr-${idx}`">
          <th v-if="idx === 0" style="min-width: 36px; max-width: 36px;" :rowspan="maxHeadersDepth">
            <div style="flex-direction: column;">
              <ignore-header-config-modal
                v-model="ignoreHeader"
                :headers="headers"
              />
              <div v-if="itemNumbering">
                No.
              </div>
            </div>
          </th>
          <th v-for="(header, idx2) in headerList" :key="`head-tr-${idx}-th-${idx2}`"
              :colspan="header.cnt"
              :rowspan="header.child ? 1 : maxHeadersDepth - idx"
              :style="{
              'min-width': header.width,
              'max-width': header.width
            }"
              :class="{'cursor' : header.sortable, 'edit-possible' : !!header.input }"
              @click.stop="onSortChange(header)"
          >
            <slot :name="`header.${header.key}`" :item="header">
              <div :title="header.text">
                {{
                  header.text
                }}
                <span v-if="header.sortable && header.sort" :class="header.sort === 'true' ? 'arrow-down' : 'arrow-up'">
                <v-icon v-if="header.sort === 'true'" x-small>mdi-arrow-down</v-icon>
                <v-icon v-else x-small>mdi-arrow-up</v-icon>
              </span>
              </div>
            </slot>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(item, idx) in filteredItems" :key="`body-tr-${idx}`"
          @click.stop="$emit('on-click-item',item)"
        >
          <th>
            <div v-if="itemNumbering">
              {{ idx + 1 }}
            </div>
            <div v-else />
          </th>
          <td v-for="(header, idx2) in leafHeaders" :key="`body-tr-${idx}-td-${idx2}`"
              :style="{
              'min-width': header.width,
              'max-width': header.width,
            }"
              :class="header.class ? header.class(item, item[header.key]) : ''"
          >
            <slot :name="`item.${header.key}`" :item="item" :v="item[header.key]">
              <div :title="item[header.key]"
                   :style="{
                    'justify-content': header.align || 'center',
                    'text-align': header.align || 'center',
                 }"
              >
                <!-- 일반 버튼 -->
                <button
                  v-if="header.input && header.input.type === 'button'"
                  :disabled="header.input.disable ? header.input.disable(item) : false"
                  :style="{
                  'background-color':!!header.input.trueValue && header.input.trueValue === item[header.key] ? header.input.trueColor : header.input.color
                }"
                  x-small
                  class="table-cell-input white--text"
                  @click.stop="header.input.callBack(item)"
                >
                  {{ header.read ? header.read(item) : (item[header.key] || '-') }}
                </button>
                <!-- 특수 입력 -->
                <button
                  v-else-if="header.input && ['datepicker', 'textarea'].includes(header.input.type)"
                  :disabled="header.input.disable ? header.input.disable(item) : false"
                  text
                  x-small
                  class="table-cell-input"
                  :class="header.input.type"
                  :style="{
                    'justify-content': header.align || 'center',
                    'text-align': header.align || 'center',
                 }"
                  @click.stop="onDialogShow(item, header)"
                >
                  {{ item[header.key] || '-' }}
                </button>
                <!-- 일반 입력 number, text -->
                <div
                  v-else-if="header.input && ['number', 'text'].includes(header.input.type)"
                  class="table-cell-input"
                  @mouseover="editBtnActive = `input-${idx}-${idx2}`"
                  @mouseleave="editBtnActive = undefined"
                >
                  <button
                    :style="{'visibility' : [editBtnActive, editModeActiveId].includes(`input-${idx}-${idx2}`) ? '' : 'hidden'}"
                    class="edit-button"
                    :disabled="`input-${idx}-${idx2}` === editModeActiveId"
                    @click.stop="onEditModeActive(`input-${idx}-${idx2}`)"
                  >
                  <span
                    class="mdi mdi-square-edit-outline"
                  />
                    <!--                    :class="editModeActiveId === `input-${idx}-${idx2}` ? 'mdi-content-save-outline' : 'mdi-square-edit-outline'"-->
                  </button>
                  <input
                    :id="`input-${idx}-${idx2}`"
                    v-model="item[header.key]"
                    :type="header.input.type"
                    :disabled="`input-${idx}-${idx2}` !== editModeActiveId"
                    :style="{
                    'text-align': header.align || 'right',
                    }"
                    :placeholder="header.input.placeholder || '-' "
                    @keyup.enter="editConfirm(item, header)"
                    @keyup.tab="editConfirm(item, header)"
                    @blur="onEditModeInactive(item, header)"
                  >
                </div>
                <!-- 일반 출력 -->
                <div
                  v-else
                  class="table-cell-normal"
                  v-html="header.read ? header.read(item, item[header.key]) : (item[header.key] || '-')"
                />
              </div>
            </slot>
          </td>
        </tr>
        <tr v-if="filteredItems.length < 1 && itemsTotalCount === 0">
          <td colspan="999">
            <div class="ma-15 justify-center">
              data is empty
            </div>
          </td>
        </tr>
        <tr v-if="isLoading">
          <td colspan="999">
            <div class="detector mb-5 mt-5">
              <v-progress-linear
                indeterminate
                size="5"
              />
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <intersection-detector
        v-if="activeInfinityScroll && !isLoading"
        @intersect="onIntersect"
      >
        <div class="detector mb-5 mt-5">
          -
        </div>
      </intersection-detector>
    </div>
    <div
      v-if="!activeInfinityScroll"
      class="infinity_scroll_table_paging"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="page"
                class="my-4"
                :length="pageLength"
              />
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-dialog
      ref="dialog"
      v-model="dialog.show"
      :return-value.sync="dialog.computedValue"
      persistent
      :width="'290px'"
    >
      <v-card
        v-if="!!dialog.type && dialog.type === 'textarea'"
      >
        <v-card-text>
          <textarea
            ref="textarea"
            v-model="dialog.computedValue"
            class="dialog-text-area"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="onDialogHide(false)"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click.stop="onDialogHide(true)"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-date-picker
        v-if="!!dialog.type && dialog.type === 'datepicker'"
        v-model="dialog.computedValue"
        no-title
        scrollable
      >
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="onDialogHide(false)"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          @click.stop="onDialogHide(true)"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
/**
 *
 */
import IntersectionDetector from "@/components/common/IntersectionDetector";
import {cloneDeep} from "lodash";
import IgnoreHeaderConfigModal from "./IgnoreHeaderConfigModal.vue";
import {DateTime} from "luxon";

export default {
  name: "InfinityScrollTable",
  components: {
    IgnoreHeaderConfigModal,
    IntersectionDetector
  },
  props: {
    // item row 별 숫자 입력 여부
    itemNumbering: {
      type: Boolean,
      default: true
    },
    // 무한 스크롤 사용 여부
    infinityScroll: {
      type: Boolean,
      default: false
    },
    // 컬럼 정보
    // 상세내용은 src/components/common/newBase/Headers.vue 참고
    headers: {
      type: Array,
      default: () => []
    },
    // 목록 아이템
    items: {
      type: Array,
      default: () => []
    },
    // 목록의 총 개수
    itemsTotalCount: {
      type: Number,
      default: undefined
    },
    // 로드중 여부
    isLoading: {
      type: Boolean,
      default: false
    },
    // 현재 적용된 정렬 옵션 정보
    sortOption: {
      type: Object,
      default: undefined,
    },
    // 현재 페이지 번호
    pageNumber: {
      type: Number,
      default: 1
    },
    // 총 페이지 번호 (마지막 페이지)
    pageLength: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      // 화면에 표시하지 않을 컬럼 정보
      ignoreHeader: [],
      // dialog 입력 시 임시 저장 요소들
      dialog: {
        show: false,
        computedValue: undefined,
        internalValue: undefined,
        callBack: undefined,
        key: undefined,
        item: undefined,
        type: undefined,
      },
      // 목록에서 바로 수정 할 수 있는 버튼 의 활성화 여부
      editBtnActive: undefined,
      // 목록에서 바로 수정하고 있는 요소의 ID
      editModeActiveId: undefined,
      // 바로수정 항목의 기존 데이터
      editOrgValue: undefined,
      // 현재 페이지
      page: 1,
    }
  },
  computed: {
    // Array 인자별로 colspan 값을 세팅한 헤더
    filteredHeaders() {
      const result = cloneDeep(this.headers)
      this.setArrayChildCnt(result)
      return result
    },

    // 가장 하위요소의 깊이
    maxHeadersDepth() {
      return this.getArrayMaxDepth(this.filteredHeaders)
    },

    // depth 별 헤더 리스트
    depthHeaders() {
      const result = []
      for (let i = 0; i < this.maxHeadersDepth; i++)
        result.push(this.getArrayForDepth(this.filteredHeaders, i + 1))
      return result
    },

    // 헤더의 leaf 값들만
    leafHeaders() {
      return this.getLeaf(this.filteredHeaders)
    },

    // 가공된 목록 아이템 (현재는 가공하고 있지 않음)
    filteredItems() {
      return this.items
    },

    // 무한 스크롤 활성 여부
    activeInfinityScroll() {
      return this.infinityScroll && (this.itemsTotalCount === undefined || this.items.length < this.itemsTotalCount)
    },
  },

  watch: {
    // 페이지 변경 시
    pageNumber(newValue, oldValue) {
      this.page = newValue
    },

    // 페이지 변경 시
    page(newValue, oldValue) {
      this.$emit('on-page-change', newValue)
    },
  },

  mounted() {

  },

  methods: {
    // Array 인자별로 colspan 값을 세팅
    setArrayChildCnt(arr) {
      arr.forEach(e => {
        if (this.ignoreHeader.includes(e.key)) {
          e.ignore = true
        }
        this.sortOption.sortBy.forEach((t, idx) => {
          if (t === e.key) {
            e.sort = this.sortOption.sortDesc[idx]
          }
        })
        let result = 0
        if (e.ignore) {
          result = 0
        } else if (!e.child) {
          result = 1
        } else {
          this.setArrayChildCnt(e.child)
          e.child.forEach(ee => {
            result += ee.cnt
          })
        }

        e.cnt = result

        if (!e.ignore && !e.key && e.cnt <= 0) {
          e.ignore = true
        }

      })
    },

    // 가장 하위요소의 깊이
    getArrayMaxDepth(arr) {
      return Array.isArray(arr) ?
        1 + Math.max(0, ...arr.map(e => this.getArrayMaxDepth(e.child))) :
        0;
    },

    // depth 별 헤더 리스트
    getArrayForDepth(arr, depth) {
      if (!arr) {
        return
      }

      const result = []

      if (depth === 1) {
        result.push(...arr.filter(e => !!e && !e.ignore))
      } else {
        result.push(...arr.map(e => this.getArrayForDepth(e.child, depth - 1)).flat(1).filter(e => !!e && !e.ignore))
      }
      return result
    },

    // leaf 요소만 리스트 형태로 반환
    getLeaf(arr) {
      const result = []
      if (!arr) return result
      arr.forEach(e => {
        if (!e.child && !e.ignore)
          result.push(e)
        else
          result.push(...this.getLeaf(e.child))
      })
      return result
    },

    // 무한 스크롤 사용시 하단에 도달했을 경우
    onIntersect() {
      console.log('onIntersect')
      if (this.isLoading) return
      this.page++
    },

    // 정렬 기준 변경
    onSortChange(e) {
      if (!e.sortable) return

      const emitData = {
        sortBy: [e.key],
        sortDesc: [this.sortOption.sortDesc[0] === 'true' ? 'false' : 'true']
      }
      this.$emit('on-sort-change', emitData)
    },

    // input dialog 표시(숨기기)
    dialogShowHide(value = false) {
      this.dialog.show = value
      if (!value) {
        this.dialog.type = undefined
        this.dialog.key = undefined
        this.dialog.internalValue = undefined
        this.dialog.item = undefined
        this.dialog.callBack = undefined
        this.dialog.computedValue = undefined
      }
    },

    // 달력 on
    onDialogShow(item, header) {
      this.dialogShowHide(true)
      this.dialog.type = header.input.type
      this.dialog.internalValue = item[header.key]
      if (this.dialog.type === 'datepicker')
        this.dialog.computedValue = item[header.key] ? this.$parseDate(this.dialog.internalValue).toISO() : this.$now().toISO()
      else if (this.dialog.type === 'textarea')
        this.dialog.computedValue = item[header.key]
      this.dialog.item = item
      this.dialog.key = header.key
      this.dialog.callBack = header.input.callBack
    },

    // 달력 off
    onDialogHide(isConfirm) {
      if (isConfirm) {
        this.dialog.internalValue =
          this.dialog.type === 'datepicker' ?
            DateTime.fromISO(this.dialog.computedValue).toFormat('yyyy-MM-dd') : this.dialog.computedValue
        this.dialog.item[this.dialog.key] = this.dialog.internalValue
        this.dialog.callBack(this.dialog.item)
      }
      this.dialogShowHide(false)
    },

    // 수정 모드 변경
    onEditModeActive(id) {
      this.editModeActiveId = id
      const target = document.getElementById(this.editModeActiveId)
      this.editOrgValue = target.value
      this.$nextTick(() => {
        target.focus()
      })
    },

    // 수정 완료
    editConfirm(item, header) {
      this.editModeActiveId = undefined
      if (header.input.type === 'number')
        item[header.key] = Number(item[header.key] || 0)
      header.input.callBack(item)
    },

    // 수정 취소
    async onEditModeInactive(item, header) {
      if (!this.editModeActiveId) return
      item[header.key] = String(this.editOrgValue || '')
      this.editOrgValue = undefined
      this.editModeActiveId = undefined
    }
  },
}
</script>

<style scoped>
.infinity_scroll_table {
  position: relative;
  height: 100%;
  width: 100%;
}

.infinity_scroll_table_paging {
  margin-top: 4px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.infinity_scroll_table_wrap {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: auto;
  border: 1px solid #ddd;
}

.infinity_scroll_table_wrap table {
  min-width: 100%;
  border-spacing: 0;
}

.infinity_scroll_table_wrap table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.infinity_scroll_table_wrap table tr th {
  background: #f8f8f8;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  font-size: 0.7125rem;
  position: relative;
}

.infinity_scroll_table_wrap table tr th.cursor {
  cursor: pointer;
}

.infinity_scroll_table_wrap table tr td {
  font-size: 0.750rem;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  min-height: 30px;
}

.infinity_scroll_table_wrap table tbody tr:nth-child(2n) {
  background: #e6eaee;
}

.infinity_scroll_table_wrap table tbody tr:hover {
  background: #adc0c5;
}

.infinity_scroll_table_wrap table tr th > div {
  padding: 2px 4px;
  width: 100%;
  min-height: 1.5rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.infinity_scroll_table_wrap table tr td > div {
  padding: 2px 4px;
  max-width: 100%;
  min-height: 30px;
  display: flex;
  align-items: center;
}

.infinity_scroll_table_wrap table tr td > div .datepicker {
  width: 100%;
  cursor: pointer;
}

.infinity_scroll_table_wrap table tr td > div .textarea {
  width: 100%;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.table-cell-input {
  display: flex;
}

button.table-cell-input {
  min-width: 20px;
  border-radius: 4px;
  height: 20px;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

button.table-cell-input:hover {
  background: #E3F2FD;
}

button.table-cell-input:disabled {
  background: #6f6f6f;
}

.table-cell-input:hover {
  color: #0e4469;
}

.table-cell-input .edit-button {
  border-radius: 8px;
  width: 24px;
  height: 24px;
  font-size: 1.25rem;
}

.table-cell-input .edit-button:hover {
  background: #E3F2FD;
}

.table-cell-input .edit-button:disabled {
  background: #6f6f6f;
}

.table-cell-input input {
  width: calc(100% - 28px);
  margin-left: 4px;
  padding: 4px;
  text-decoration: underline;
}

.table-cell-input input:focus {
  outline: none;
  color: #0066cc;
}

.table-cell-input input[type=number]::-webkit-inner-spin-button,
.table-cell-input input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.table-cell-normal {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.table-cell-normal:hover {
  font-weight: bold;
}

.dialog-text-area {
  width: calc(100% - 8px);
  min-height: 400px;
  margin: 16px 0px 0px 0px;
  padding: 4px;
  border: 1px solid #eeeeee
}
</style>